import { bind } from '@react-rxjs/core'
import { Observable, of } from 'rxjs'

import { dispensaryBySlugQuery } from '../../../groq/sanity-dispensaries/dispensary'
import { SanityDispensaryDocument } from '../../../groq/sanity-dispensaries/types'
import { FetchResult } from '../../../lib/fetch'
import { dispensariesClientCdn, fetchQuery } from '../../sanity-dispensaries/client'

const nullResult = { _tag: 'Right' as const, data: null }

const fetchDispensaryBySlug$ = (
  slug: string | null | undefined,
): Observable<FetchResult<SanityDispensaryDocument | null>> => {
  if (!slug) return of(nullResult)

  return fetchQuery(dispensaryBySlugQuery, {
    slug,
  })(dispensariesClientCdn)
}

export const [useSanityDispensaryBySlug] = bind(fetchDispensaryBySlug$)
